<template>
    <v-layout row justify-center v-if="visible">
        <v-card elevation="0" style="max-width: 1000px;">
            <v-card-title>
                <h3>{{ $t("multiSaw") }}</h3>
            </v-card-title>
            <v-card-text>
                <v-layout wrap row dense>
                    <v-flex xs12 sm2>
                        <v-layout wrap dense>
                            <v-flex xs12 sm10>
                                <v-text-field
                                    :label="$t('maxSawsAmount')"
                                    :hint="$t('maxSawsAmount')"
                                    :rules="[rules.required, rules.maxAmount]"
                                    @change="changeHandler"
                                    v-model="maxAmount.val"
                                    required
                                    dense
                                    ref="maxSaws"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap dense>
                            <v-flex xs12 sm10>
                                <v-text-field
                                    :label="$t('kerf')"
                                    :hint="`${$t('kerf')}, ${$t('mm')}`"
                                    :suffix="$t('mm')"
                                    :rules="[rules.required, rules.kerf]"
                                    @change="changeHandler"
                                    v-model="kerf.val"
                                    required
                                    dense
                                    ref="kerf"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 sm2>
                        <v-layout dense>
                            <v-flex xs12>
                                <span>{{ $t("patternType") }}</span>
                                <v-radio-group v-model="patternType" class="mt-1">
                                    <v-radio :value="1" :label="`${$t('even')}`"></v-radio>
                                    <v-radio :value="2" :label="`${$t('odd')}`"></v-radio>
                                    <v-radio :value="3" :label="`${$t('symmetric')}`"></v-radio>
                                    <v-radio :value="4" :label="`${$t('asymmetric')}`"></v-radio>
                                </v-radio-group>
                            </v-flex>
                        </v-layout>
                    </v-flex>

                    <v-divider vertical class="mx-3"></v-divider>

                    <v-flex xs12 sm4>
                        <v-layout wrap dense>
                            <v-flex xs12>
                                <v-checkbox
                                    v-model="useEdgeTrimmer"
                                    :label="$t('edgeTrimmerUsed')"
                                    hide-details
                                    dense
                                ></v-checkbox>
                                <v-checkbox
                                    v-model="splitCentralBoards"
                                    :label="$t('centralBoardsCutting')"
                                    :disabled="!useEdgeTrimmer"
                                    hide-details
                                    dense
                                ></v-checkbox><!-- Central boards cutting -->
                                <v-layout wrap dense class="mt-2">
                                    <v-flex xs6 class="pr-2">
                                        <v-text-field
                                            :label="`${$t('maxSawsAmount')}`"
                                            :hint="$t('maxSawsAmount')"
                                            :rules="[rules.required, rules.maxAmount]"
                                            v-model="edgeTrimmerMaxAmount.val"
                                            @change="changeHandler"
                                            ref="edgeTrimmerMaxAmount"
                                            required
                                            dense
                                            :disabled="!useEdgeTrimmer"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            :label="$t('kerf')"
                                            :hint="`${$t('kerf')}, ${$t('mm')}`"
                                            :suffix="$t('mm')"
                                            :rules="[rules.required, rules.kerf]"
                                            v-model="edgeTrimmerKerf.val"
                                            @change="changeHandler"
                                            required
                                            dense
                                            ref="edgeTrimmerKerf"
                                            :disabled="!useEdgeTrimmer"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>

                    <v-divider vertical class="mx-3"></v-divider>

                    <v-flex xs12 sm3>
                        <v-layout wrap dense>
                            <v-checkbox
                                v-model="useCleanSaws"
                                @change="changeHandler"
                                :label="$t('cleanSawsUsed')"
                                hide-details
                                dense
                            ></v-checkbox>
                            <v-flex xs12 sm6 class="mt-2">
                                <v-text-field
                                    :label="$t('cleanKerf')"
                                    :hint="`${$t('kerf')}, ${$t('mm')}`"
                                    :suffix="$t('mm')"
                                    :rules="[rules.required, rules.cleanKerf]"
                                    @change="changeHandler"
                                    v-model="cleanKerf.val"
                                    required
                                    dense
                                    :disabled="!useCleanSaws"
                                    ref="cleanKerf"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-layout>
</template>

<script>
    export default {
        name: "MultiSawSettings",

        data () {
            return {
                changed:       false,
                checkingInput: false,
                disableWatch:  false,
                maxAmount:     { val: 0, min: 0, max: 0 },
                kerf:          { val: 0, min: 0, max: 0 },
                edgeTrimmerMaxAmount:     { val: 0, min: 0, max: 0 },
                edgeTrimmerKerf:          { val: 0, min: 0, max: 0 },
                patternType:   1,
                sawWidthDep:   false,
                useEdgeTrimmer: true,
                splitCentralBoards: false,
                useCleanSaws: false,
                cleanKerf: { val: 0, min: 0, max: 0 },
                rules: {
                    required:  value => !!value || this.$t("requiredField"),
                    maxAmount: value => (value >= this.maxAmount.min && value <= this.maxAmount.max) || this.$t("incorrectValue"),
                    kerf:      value => (value >= this.kerf.min && value <= this.kerf.max) || this.$t("incorrectValue"),
                    edgeTrimmerMaxAmount: value => (value >= this.edgeTrimmerMaxAmount.min && value <= this.edgeTrimmerMaxAmount.max) || this.$t("incorrectValue"),
                    edgeTrimmerKerf:      value => (value >= this.edgeTrimmerKerf.min && value <= this.edgeTrimmerKerf.max) || this.$t("incorrectValue"),
                    cleanKerf:      value => (value >= this.cleanKerf.min && value <= this.cleanKerf.max) || this.$t("incorrectValue")
                },
                visible: false
            }
        },

        watch: {
            patternType: function () { this.changed = !this.disableWatch ? true : this.changed; },
            sawWidthDep: function () { this.changed = !this.disableWatch ? true : this.changed; },
            useEdgeTrimmer: function () { this.changed = !this.disableWatch ? true : this.changed; },
            splitCentralBoards: function () { this.changed = !this.disableWatch ? true : this.changed; },
            useCleanSaws: function () { this.changed = !this.disableWatch ? true : this.changed; },
            visible:     function (val) { this.changed = val ? false : this.changed; }
        },

        methods: {
            changeHandler () {
                if (!this.disableWatch) { this.changed = true; }
            }
        }
    }
</script>
